import InternalStaticAnchorTeamProfile from 'models/application/anchor/types/internalStatic/types/TeamProfile';

export default class InternalStaticAnchorTeamProfileService {
	toModel(anchor) {
		return new InternalStaticAnchorTeamProfile(anchor);
	}
}
